import apiClient from "../../../../utils/interceptor";
import { API_URLS } from "../../../../constants";

// Get vehicles by company
export const getCompanyVehicles = async (companyId) => {
    try {
        const response = await apiClient.get(
            `${API_URLS.VEHICLE_TAG.GET_COMPANY_VEHICLES}/${companyId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching vehicles:", error);
        throw error;
    }
};

// Create vehicle
export const createVehicleTag = async (vehicleParams) => {
    try {
        const response = await apiClient.post(
            API_URLS.VEHICLE_TAG.CREATE_VEHICLE_TAG,
            vehicleParams
        );
        return response.data;
    } catch (error) {
        console.error("Error creating vehicle:", error);
        throw error;
    }
};

// Delete vehicle
export const deleteVehicleTag = async (companyId, vehicleId) => {
    try {
        const response = await apiClient.delete(
            API_URLS.VEHICLE_TAG.DELETE_VEHICLE_TAG,
            {
                data: { company_id: companyId, vehicle_id: vehicleId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting vehicle:", error);
        throw error;
    }
};